export const CONTACT_EMAIL = "people@tokenterminal.xyz"

// Must match the dropdown values of the HubSpot form exactly
export const ORGANIZATION_TYPES = [
  "Asset manager or ETF issuer",
  "Bank or broker",
  "Hedge fund or trading firm",
  "Venture or crypto fund",
  "Exchange or trading platform",
  "Index, data or analytics provider",
  "Protocol, chain or foundation",
  "Research, media or education",
  "Other",
] as const

// HubSpot stores `value`; the form shows `label`. They differ where GTM renamed an option.
export const INTERESTS = [
  { value: "API access", label: "API access" },
  { value: "Data downloads", label: "Data downloads" },
  {
    value: "Integrations or embedding our data",
    label: "Embedding Token Terminal data in a product",
  },
  {
    value: "Getting our project’s data on Token Terminal",
    label: "Listing a project on Token Terminal",
  },
  { value: "Something else", label: "Something else" },
] as const

/** `?interest=` values that preselect a topic on /contact */
export const INTEREST_PARAMS: Record<
  string,
  (typeof INTERESTS)[number]["value"]
> = {
  listing: "Getting our project’s data on Token Terminal",
}

/** Every "Get listed" button links here */
export const GET_LISTED_URL = "/contact?interest=listing"

export type DemoRequest = {
  firstName: string
  lastName: string
  email: string
  company: string
  organizationType: (typeof ORGANIZATION_TYPES)[number]
  interest?: (typeof INTERESTS)[number]["value"]
  message: string
  // Page the visitor came from, for attribution
  pageUri: string
}

const HUBSPOT_SUBMIT_URL =
  "https://api.hsforms.com/submissions/v3/integration/submit/27184920/1998738f-f5c7-4c66-88bd-0b8269747e6e"

const CONTACT = "0-1"
const COMPANY = "0-2"

type HubSpotError = { errorType: string; message: string }

/**
 * Sends the request to the "Contact sales" HubSpot form.
 * Resolves to "invalid-email" when HubSpot rejects the email (bad or blocked domain), throws on other errors.
 */
export async function submitDemoRequest(request: DemoRequest) {
  const fields = [
    { objectTypeId: CONTACT, name: "firstname", value: request.firstName },
    { objectTypeId: CONTACT, name: "lastname", value: request.lastName },
    { objectTypeId: CONTACT, name: "email", value: request.email },
    { objectTypeId: CONTACT, name: "company", value: request.company },
    {
      objectTypeId: COMPANY,
      name: "organization_type",
      value: request.organizationType,
    },
    {
      objectTypeId: CONTACT,
      name: "what_are_you_interested_in",
      value: request.interest,
    },
    { objectTypeId: CONTACT, name: "message", value: request.message },
  ].filter((field) => field.value)

  const response = await fetch(HUBSPOT_SUBMIT_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      fields,
      context: { pageUri: request.pageUri, pageName: document.title },
    }),
  })
  if (response.ok) return "sent"

  const body: { errors?: HubSpotError[] } = await response
    .json()
    .catch(() => ({}))
  if (
    body.errors?.some(
      ({ errorType }) =>
        errorType === "INVALID_EMAIL" || errorType === "BLOCKED_EMAIL"
    )
  ) {
    return "invalid-email"
  }
  throw new Error(`HubSpot form submit failed with ${response.status}`)
}
